module.exports = __webpack_public_path__ + "img/logo.3ff173b4.png";